export type TreemapItem = {
    label: string;
    value: number;
    change: number;
};

export function renderTreemapChart(container: HTMLElement, items: TreemapItem[]): void {
    const total = items.reduce((sum, item) => sum + Math.max(item.value, 0), 0);
    if (total <= 0) {
        container.innerHTML = '<div class="wm-empty">No treemap data</div>';
        return;
    }

    const blocks = items.map((item) => {
        const widthPct = Math.max(8, (Math.max(item.value, 0) / total) * 100);
        const up = item.change >= 0;
        const intensity = Math.min(0.85, 0.2 + Math.abs(item.change) / 10);
        const bg = up
            ? `rgba(21,181,122,${intensity})`
            : `rgba(217,71,54,${intensity})`;

        return `
          <div class="v2-treemap__block" style="flex-basis:${widthPct}%;background:${bg};">
            <span class="v2-treemap__label">${item.label}</span>
            <span class="v2-treemap__value">${item.change.toFixed(2)}%</span>
          </div>
        `;
    }).join('');

    container.innerHTML = `<div class="v2-treemap">${blocks}</div>`;
}
